import React from 'react';
import type { ProductVariantTileViewModel } from '@rocco/ui/tile-product/view-models/product';
import { darken, meetsContrastGuidelines } from 'polished';
import { isColorString } from '../../../utils/color-helpers';

interface ProductTileVariantsProps {
    variants: ProductVariantTileViewModel[];
    limit?: number;
}

export const ProductTileVariants = (props: ProductTileVariantsProps) => {
    const { variants, limit = 5 } = props;
    const colorToCompareWith = '#fafafa';

    return (
        <div className="flex h-7 items-center gap-2.5">
            <div className="flex gap-1.5">
                {variants.slice(0, limit).map((variant, index) => {
                    const image = variant.image.src;

                    return (
                        <div key={`${variant.color}-${index}`}>
                            <div
                                className="size-3.5 overflow-hidden rounded-full"
                                style={
                                    image
                                        ? {}
                                        : {
                                              backgroundColor:
                                                  !isColorString(
                                                      variant.color
                                                  ) ||
                                                  meetsContrastGuidelines(
                                                      variant.color,
                                                      colorToCompareWith
                                                  ).AA
                                                      ? variant.color
                                                      : darken(
                                                            0.2,
                                                            variant.color
                                                        ),
                                          }
                                }
                            >
                                {image ? (
                                    <img src={image} alt={variant.image.alt} />
                                ) : null}
                            </div>
                        </div>
                    );
                })}
            </div>

            {variants.length > limit && (
                <div className="text-base font-medium leading-none text-gray-500">
                    (+{variants.length - limit})
                </div>
            )}
        </div>
    );
};
